import styled from "styled-components";

/**
 * Wrapper principal do rodapé (Desktop)
 */
export const FooterWrapperDesktop = styled.div`
  background-color: ${({ theme }) => theme.colors.lightBlue};

  & > div {
    max-width: 1628px;
    margin: 0 auto;
    display: flex;
  }
`;

/**
 * Conteúdo do rodapé (Desktop)
 */
export const FooterContentDesktop = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(8)};
  margin-top: ${({ theme }) => theme.spacing(12)};
  margin-bottom: ${({ theme }) => theme.spacing(4)};
`;

/**
 * Wrapper do conteúdo do rodapé (Desktop)
 */
export const FooterContentWrapperDesktop = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: auto;
`;

/**
 * Wrapper do logo (Desktop)
 */
export const LogoWrapperDesktop = styled.a`
  flex: 1;
  min-width: ${({ theme }) => theme.spacing(42)};

  & > svg {
    width: ${({ theme }) => theme.spacing(42)};
    height: ${({ theme }) => theme.spacing(11)};
  }
`;

/**
 * Wrapper do menu de navegação (Desktop)
 */
export const NavWrapperDesktop = styled.nav`
  flex: 2;
  display: flex;
  justify-content: center;

  & > ul {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(1)};
    align-items: flex-start;

    & > li {
      color: ${({ theme }) => theme.colors.darkBlue};
      border: none;
    }
  }
`;

/**
 * Descrição do rodapé (Desktop)
 */
export const NavDescriptionDesktop = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  padding-right: ${({ theme }) => theme.spacing(14)};
`;

/**
 * Wrapper dos botões (Desktop)
 */
export const ButtonWrapperDesktop = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
`;
